import type { TrackingDataV2 } from '@oneaudi/audi-tracking-service';
import { EventAction } from '../../utils/tracking';

interface UseSearchTrackingParams {
  useAiSearch: boolean;
  searchLabel: string;
  navigationItemsAmount: number;
}

/**
 * Hook to generate consistent search button tracking events for both mobile and desktop.
 * Prevents drift between desktop (AudiHeaderSearchButton_alpha) and mobile (AudiHeaderMenuButton).
 */
export const useSearchTracking = ({
  useAiSearch,
  searchLabel,
  navigationItemsAmount,
}: UseSearchTrackingParams): TrackingDataV2 => {
  return {
    event: {
      eventInfo: {
        eventAction: useAiSearch ? EventAction.INTERNAL : EventAction.NAVIGATION,
        eventName: useAiSearch
          ? 'one header - click to open ai search'
          : 'one header - search access',
      },
      attributes: {
        componentName: EventAction.COMPONENT_NAME,
        label: useAiSearch ? 'AI Search' : searchLabel,
        targetURL: '',
        clickID: '',
        elementName: 'icon',
        value: '',
        pos: `${navigationItemsAmount + 1}`,
      },
    },
  };
};
